export const getMillisecond = (second) => second * 1000;
